const Content = {
  'homepage': {
    'headline': 'Well-designed and thoughtfully executed research fundamentally expands',
    'statement1': 'Creativity',
    'statement2': 'Risk Taking',
    'statement3': 'Story Development'
  }
};

export { Content };
